
import * as api from '../../apiClient';
import { ValidationError } from '../../global/types';

export enum ProductStockStatus {
    Ok = 0,
    LowStock = 1,
    OutOfStock = 2
}

export interface ProductQuantity {
    dateInLocalTime: Date;
    currentStock: number;
    availableStock: number;
    paidAllocatedStock: number;
    unpaidAllocatedStock: number;
    stockState: ProductStockStatus;
}

export interface ProductStockLevel {
    productId: string;
    productName: string;
    productVariantId: string | null;
    productVariantName: string | null;
    quantities: ProductQuantity[];
}

export enum InventoryAction {
    Sale = 1,
    Restock = 2,
    Adjustment = 3,
}

export enum InventoryStatus {
    Pending = 1,
    Completed = 2,
    Cancelled = 3,
}

export interface ProductStockState {
    isLoading: boolean;
    venueId: string;
    stockDate: Date;
    stockLevels: ProductStockLevel[];
    loadError: api.ApiError | null;
    isLoadingOverview: boolean;
    overviewStockDate: Date;
    overviewStockLevels: ProductStockLevel[];
    overviewLoadError: api.ApiError | null;
}

export enum ProductStockActionTypes {
    RequestVenueStockLevels = 'REQUEST_VENUE_STOCK_LEVELS',
    ReceivedVenueStockLevels = 'RECEIVE_VENUE_STOCK_LEVELS',
    RequestVenueStockOverview = 'REQUEST_VENUE_STOCK_OVERVIEW',
    ReceivedVenueStockOverview = 'RECEIVE_VENUE_STOCK_OVERVIEW',
    ProductStockChanged = 'PRODUCT_STOCK_CHANGED',
    ReceivedIndividualProductStock = 'RECEIVE_INDIVIDUAL_PRODUCT_STOCK',
    ReceivedIndividualProductStockOverview = 'RECEIVE_INDIVIDUAL_PRODUCT_STOCK_OVERVIEW',
    VenueChanged = 'VENUE_CHANGED'
}

export interface LoadVenueStockLevels {
    type: ProductStockActionTypes.RequestVenueStockLevels;
    stockDate: Date;
}

export interface ReceiveVenueStockLevels {
    type: ProductStockActionTypes.ReceivedVenueStockLevels;
    venueId: string;
    stockDate: Date;
    stockLevels: ProductStockLevel[];
    error: api.ApiError | null;
}

export interface LoadVenueStockOverview {
    type: ProductStockActionTypes.RequestVenueStockOverview;
    stockDate: Date;
}

export interface ReceiveVenueStockOverview {
    type: ProductStockActionTypes.ReceivedVenueStockOverview;
    venueId: string;
    stockDate: Date;
    stockLevels: ProductStockLevel[];
    error: api.ApiError | null;
}

export interface ProductStockChanged {
    type: ProductStockActionTypes.ProductStockChanged;
    venueId: string;
    productId: string;
    productVariantId: string | null
}

export interface ReceivedIndividualProductStock {
    type: ProductStockActionTypes.ReceivedIndividualProductStock;
    stockLevels: ProductStockLevel[];
    err: api.ApiError | null
}

export interface  ReceivedIndividualProductStockOverview {
    type: ProductStockActionTypes.ReceivedIndividualProductStockOverview;
    stockLevels: ProductStockLevel[];
    err: api.ApiError | null
}

export interface VenueChanged {
    type: ProductStockActionTypes.VenueChanged;
    venueId: string;
}